import { render, staticRenderFns } from "./clientData.vue?vue&type=template&id=2143aa50&scoped=true&"
import script from "./clientData.vue?vue&type=script&lang=js&"
export * from "./clientData.vue?vue&type=script&lang=js&"
import style0 from "./clientData.vue?vue&type=style&index=0&id=2143aa50&prod&lang=scss&scoped=true&"
import style1 from "./clientData.vue?vue&type=style&index=1&id=2143aa50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2143aa50",
  null
  
)

export default component.exports